import { render, staticRenderFns } from "./CoozzySearchMultiselect.vue?vue&type=template&id=08cebd02&scoped=true"
import script from "./CoozzySearchMultiselect.vue?vue&type=script&lang=js"
export * from "./CoozzySearchMultiselect.vue?vue&type=script&lang=js"
import style0 from "./CoozzySearchMultiselect.vue?vue&type=style&index=0&id=08cebd02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cebd02",
  null
  
)

export default component.exports